export const hasPermission = () => {
	return Notification.permission === "granted"
}

export const requestPermission = async () => {
	return await Notification.requestPermission();
}

export const getSubscription = async () => {
	return await navigator.serviceWorker.ready.then(async (registration) => {
		return await registration.pushManager.getSubscription();
	});
}

export const subscribe = async (key) => {
	const registration = await navigator.serviceWorker.ready;
	const subscription = await registration.pushManager.subscribe({
		userVisibleOnly: true,
		applicationServerKey: key,
	});
	return subscription;
}

export const unsubscribe = async () => {
	const subscription = await getSubscription();
	if (subscription) {
		await subscription.unsubscribe();
	}
	return subscription;
}